import Vue from 'vue';
import VueResize from 'vue-resize';
import VueI18n from 'vue-i18n';
import VueParticles from 'vue-particles';
// import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import App from './App.vue';
import store from './store';
import router from './router';


import 'vue-resize/dist/vue-resize.css';

import 'font-awesome/css/font-awesome.css';
import 'flag-icon-css/css/flag-icon.min.css';
import { _queryAllDictionaries } from './api/sys/sysDictionaryApi';
import { _queryLocation } from './api/sys/locationApi';
import '../public/main.less';
import {
  message,
} from 'ant-design-vue';


Vue.config.productionTip = false;

Vue.use(VueParticles);

Vue.use(VueResize);

Vue.use(VueI18n);

Vue.use(Antd, { size: 'small' });


router.beforeEach((to, from, next) => {
  // 检验是否需要登录验证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查token是否存在
    if (!store.state.token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      // 若token存在，检验时间是否超时
      const lastTime = localStorage.getItem('lastTime');
      if (lastTime != null) {
        const time = new Date().getTime() - new Date(localStorage.getItem('lastTime')).getTime();
        localStorage.setItem('lastTime', new Date());
        if (time > 1000 * 60 * 30) {
          next({
            path: '/login',
            query: { redirect: to.fullPath },
          });
        }
      } else {
        // 操作则更新时间
        localStorage.setItem('lastTime', new Date());
      }
      next();
    }
  } else {
    // 不需要登录验证时直接进行跳转
    next();
  }
});


Vue.directive('has', {
  inserted(el, binding) {
    function permissionJudge(value) {
      const set = new Set(JSON.parse(localStorage.getItem('BUTTONS')));
      return set.has(value);
    }

    if (!permissionJudge(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});


// 注册 (指令函数)
Vue.directive('dict', {
  inserted(el, binding) {
    const { parentNode } = el;
    parentNode.removeChild(el);
    parentNode.append(store.getters.getDictionaryDataByKey(binding.value).name);
  },
});

Vue.prototype.$dict = (code, value) => {
  const key = `${code}-${value}`;
  return store.getters.getDictionaryDataByKey(key) ? store.getters.getDictionaryDataByKey(key).name : '';
};

const locate = localStorage.getItem('language') || 'zh-CN';

const messages = {
  en: {
    LOGIN_NAME: 'Login name',
    PASSWORD: 'Password',
    LOGIN: 'Login',
  },
  'zh-CN': {
    LOGIN_NAME: '账号',
    PASSWORD: '密码',
    LOGIN: '登录',
  },
};

let i18n = new VueI18n({
  locale: locate, // set locale
  messages, // set locale messages
});


Promise.all([_queryAllDictionaries(), _queryLocation()])
  .then(([result, locationResult]) => {
    if (result !== null && result !== undefined) {
      result.forEach((x) => {
        store.commit('addDictionary', {
          key: x.code,
          value: x,
        });
        x.data.forEach((d) => {
          store.commit('addDictionaryData', {
            key: `${x.code}-${d.code}`,
            value: d,
          });
        });
      });
      const {
        languages,
        i18NDetails,
      } = locationResult;
      languages.forEach((x) => {
        store.commit('addLanguage', x);
      });
      i18NDetails.forEach((x) => {
        if (messages[x.languageCode]) {
          messages[x.languageCode][x.i18nCode] = x.value;
        }
      });
      i18n = new VueI18n({
        locale: locate, // set locale
        messages, // set locale messages
      });

      // } else {
      //   message.error("服务器异常",2)
    }
  });

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
